var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from "vuex-class";
import RelationCheckbox from '~/components/smart-collection/message-collection/relation-checkbox.vue';
import MessageSendList from '~/components/smart-collection/message-collection/message-send-list.vue';
var MessageCollectionModule = namespace('message-collection');
var MessageSendRelation = /** @class */ (function (_super) {
    __extends(MessageSendRelation, _super);
    function MessageSendRelation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkedRelation = [];
        _this.dialog = {
            messageSendList: false,
        };
        return _this;
    }
    Object.defineProperty(MessageSendRelation.prototype, "sendTarget", {
        get: function () {
            return this.checkedRelation;
        },
        enumerable: false,
        configurable: true
    });
    MessageSendRelation.prototype.submit = function () {
        if (this.checkedRelation.length === 0) {
            this.$message.warning('请先选择发送对象');
            return;
        }
        this.updateCheckRelation(this.checkedRelation);
        this.dialog.messageSendList = true;
    };
    __decorate([
        MessageCollectionModule.Action
    ], MessageSendRelation.prototype, "updateRelationState", void 0);
    __decorate([
        MessageCollectionModule.Action
    ], MessageSendRelation.prototype, "updateCheckRelation", void 0);
    MessageSendRelation = __decorate([
        Component({
            components: {
                RelationCheckbox: RelationCheckbox,
                MessageSendList: MessageSendList
            }
        })
    ], MessageSendRelation);
    return MessageSendRelation;
}(Vue));
export default MessageSendRelation;
